exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-2e59c683]{margin:30px}.dashboard-text[data-v-2e59c683]{font-size:30px;line-height:46px}.no-line-table[data-v-2e59c683] .el-table__row>td{border:none}.no-line-table[data-v-2e59c683] .el-table::before{height:0}\n", ""]);

// exports
